export enum ActionEnum {
	ACKNOWLEDGE = 'acknowledge',
	ACTIVATE = 'active',
	ASSIGN = 'assign',
	COMPLAIN = 'complain',
	CONFIGURE = 'configuration',
	COPY = 'copy',
	CREATE = 'create',
	DECOMMISSION = 'decommission',
	DEFAULT = 'default',
	DELETE = 'deleted',
	DETAILS = 'details',
	DISABLE = 'disable',
	DOWNLOAD = 'download',
	EDIT = 'edit',
	EXTEND = 'extend',
	EXPORT = 'export',
	FCC_DATACENTER = 'fccDatacenter',
	FINAL_EXPORT_CONFIRM = 'finalExportConfirm',
	IMPORT = 'import',
	INACTIVE = 'inactive',
	KEYWORD_CHANGE = 'keywordChange',
	LINK = 'link',
	MANAGE_TENANT = 'manageTenant',
	MANIFEST_ASSIGN = 'manifestAssign',
	MANUAL_EXPORT = 'manualExport',
	PASSWORD_CHANGE = 'passwordChange',
	PASSWORD_RESET = 'passwordReset',
	PATCH = 'patch',
	PRINT = 'print',
	REACTIVATE = 'reactivate',
	REFRESH = 'refresh',
	REINITIALIZE = 'reinitialize',
	REQUEST_TSS = 'requestTss',
	RESET = 'reset',
	RETURN = 'return',
	SUSPEND = 'suspended',
	TAXATION_REPORTING_CREATE = 'taxationReportingCreate',
	TAXATION_REPORTING_SUBMIT = 'taxationReportingSubmit',
	USAGE = 'usage'
}

export enum ActionIconTypeEnum {
	Image = 'image',
	StyleClass = 'style-class',
	SVG = 'svg',
}

export enum ActionIconSizeEnum {
	Large = 'large',
	Medium = 'medium',
	Small = 'small',
}

export enum ActionDisplayModeEnum {
	Inline = 'inline',
	DropdownItem = 'dropdown-item',
	Standalone = 'standalone',
}
